import data from '@/data/service-pages.json';

export type RelatedKind = 'projects' | 'websites' | 'extensions' | 'videos';

export interface ServicePageData {
  slug: string;
  label: string;
  title: string;
  description: string;
  keywords: string;
  h1: string;
  intro: string;
  offerings: { title: string; text: string }[];
  stack: string[];
  faq: { q: string; a: string }[];
  related: { kind: RelatedKind; heading: string; blurb: string };
  alsoSee: string[];
}

export interface ServicesHubData {
  title: string;
  description: string;
  h1: string;
  intro: string;
}

export const servicesHub: ServicesHubData = data.hub;
// Not a service page, but /templates needs its own prerendered <head> for the
// same reason — keeping its copy here means the page and the build share it.
export const templatesMeta: { title: string; description: string } = data.templates;
export const servicePages: ServicePageData[] = data.pages as ServicePageData[];

export const getServicePage = (slug: string | undefined) => servicePages.find((page) => page.slug === slug);

// Where a client goes to actually hire — same profiles as the Person schema
// on the homepage.
export const HIRE_LINKS = {
  fiverr: 'https://www.fiverr.com/khanyousafza662',
  upwork: 'https://www.upwork.com/freelancers/~01c53cabd074392a06',
  email: 'mailto:ahmadyousafzai30@gmail.com',
} as const;
